export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8719.ce9b85e4.jpg";